import { ProtectedJsonAPI } from '.'

export const Notifications = ProtectedJsonAPI.extend(
  '/notifications',
  {
    show:         endpoint => endpoint,
    create:       endpoint => endpoint.method('post'),
    bulkUpdate:   endpoint => endpoint.method('put').path('bulk_update')
  }
)